import { takeLatest, call, all, put, fork } from 'redux-saga/effects'

import * as actions from '../actions/actions'

import { roles } from "../../api/userApi"

export default function* roleSaga() {
  yield all([
    fork(watchFetchRolesRequest)
  ]);
}

function* watchFetchRolesRequest() {
  yield takeLatest(
    actions.FETCH_ROLES_REQUEST,
    fetchRolesRequest
  )
}

function* fetchRolesRequest() {
  try {
    let { data } = yield call(roles)
    yield put({ type: actions.FETCH_ROLES_SUCCESS, roles: data })
  } catch (error) {
    if(error.response){
      yield put({ type: actions.FETCH_ROLES_FAILURE, error: error.response })
      yield put({ type: actions.FETCH_ERROR_REQUEST_SERVER, error: error.response })
    }else if(error.request)
    {
      yield put({ type: actions.FETCH_ERROR_REQUEST_CLIENT, error: error })
    }
  }
}